import { ref } from 'vue'
import { defineStore } from 'pinia'
import { queryProductGatewayList } from '@/api'
import { CODE_ENUM } from '@/common/enum'

export const useProductStore = defineStore('product', () => {
  // 网关产品
  const productGetewayType: any = ref([])
  const queryGetewayType = async () => {
    const res: any = await queryProductGatewayList()
    if (res?.code === CODE_ENUM.SUCCESS) {
      productGetewayType.value = (res.data || []).map(
        ({ productKey, productName, ...p }: any) => {
          return {
            code: productKey,
            name: productName,
            ...p,
          }
        }
      )
    }
  }

  return { queryGetewayType, productGetewayType }
})
